import type { RouteObject } from "react-router-dom";

/*
  The Deliverables view of the 2026-11-03 design (rebuild package 4.2F). Loaded when first opened, like the Items view. Who may open
  the address is in `app/screens.ts`; it is not repeated here.
*/

export const routes: RouteObject[] = [{ path: "/deliverables", lazy: async () => ({ Component: (await import("./DeliverablesView")).DeliverablesView }) }];
